import React from 'react';
import { supabase } from '../supabaseClient';
import { KUTU_SINIFI, sutunDugmesiStili } from './tasarim';

// ═════════════════════════════════════════════════════════════════
// LOGOUT — TEK KAYNAK (3 Eki 2026)
//
// 🔑 Serkan: *"super adminde logout yok ben mi göremiyorum"* → **A**: admin paneldeki LOGOUT'un aynısı, süper admin
//    sol sütununun altında. 🔴 Kusur: 1 Eki'de DASHBOARD kalkınca süper admin'in tek çıkışı (← DASHBOARD → dashboard'daki
//    çıkış) da gitti, yerine bir şey konmadı. Artık iki panel de bu düğmeyi çizer — biri değişirse öbürü de değişir.
// `dar`: daraltılmış sütunda kare düğme (yalnız simge). `sonra`: oturum kapandıktan sonra gidilecek ekran.
// ═════════════════════════════════════════════════════════════════

export default function CikisDugmesi({ dar = false, sonra }) {
  return (
    <button onClick={async () => { await supabase.auth.signOut(); sonra?.(); }}
      data-testid="sidebar-logout" className={KUTU_SINIFI} title="Log out"
      style={sutunDugmesiStili('cikis', dar)}>
      <span style={{ width:20, textAlign:'center', fontSize:16 }}>⎋</span>
      {!dar && <span>LOGOUT</span>}
    </button>
  );
}
